import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { IntegrationFormTypes, SettingsFormTypes } from "models/formTypes";
import { StyleEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { VismaAdvisorFormContainerProps } from "models/propTypes/integrationsPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import VismaAdvisorForm from "./vismaAdvisorForm";
//#endregion
import * as Yup from "yup";

const VismaAdvisorFormContainer: ForwardRefRenderFunction<FormHandles, VismaAdvisorFormContainerProps> = (
  props,
  ref
) => {
  const isPending = props.vismaAdvisorStatus === "PendingConfirmation";

  const validationSchema = Yup.object<IntegrationFormTypes.VismaAdvisorConnect>({
    vismaAdvisorAction: Yup.boolean(),
    vismaAdvisorDescription: Yup.string(),
  });

  const defaultValues: IntegrationFormTypes.VismaAdvisorConnect = {
    // Pending starts on "yes, right agency"; switching it off and saving discards the login.
    vismaAdvisorAction: isPending,
  };

  const handleSubmit = async (values: IntegrationFormTypes.VismaAdvisorConnect) => {
    if (isPending) {
      if (!props.onVismaAdvisorConfirmClick) throw new Error("onVismaAdvisorConfirmClick handler is required.");
      const isRightAgency = values.vismaAdvisorAction === true;
      await props.onVismaAdvisorConfirmClick(isRightAgency);
      // Return the settled row: the form writes this back over the pending one, and must not rely on the
      // status reload landing first.
      return props.submitResultFormatter?.(
        (isRightAgency
          ? {
              ...props,
              isActive: true,
              statusLabel: undefined,
              statusDisplayType: undefined,
              vismaAdvisorStatus: "Active",
            }
          : {
              ...props,
              isActive: false,
              statusLabel: TranslationKeys.Integrations.NotConnected,
              statusDisplayType: StyleEnums.DisplayType.Warning,
              vismaAdvisorStatus: undefined,
              vismaAdvisorAgencyName: undefined,
            }) as SettingsFormTypes.IntegrationItem
      );
    }

    if (values.vismaAdvisorAction) {
      if (!props.onVismaAdvisorLoginClick) throw new Error("onVismaAdvisorLoginClick handler is required.");
      // Navigates to Visma; the callback brings the user back to this page.
      await props.onVismaAdvisorLoginClick();
    }

    return props.submitResultFormatter?.({ ...props } as SettingsFormTypes.IntegrationItem);
  };

  return (
    <VismaAdvisorForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(VismaAdvisorFormContainer);
